const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    productMedia: document.querySelector('[data-productMedia]')
  };

  const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
  window.productMedia = mediaJSON;
  class TemplateProductJS {
    constructor() {
      this.reviewCustomization();
      this.stickyThumbnails();
    }

    stickyThumbnails(){
      let headerHeight = document.querySelector('header').clientHeight;
      document.querySelector('[  data-productSticky]').style.top = `${headerHeight}px`
    }

  

    reviewCustomization(){
      let reviewInterval = setInterval(() => {
        if(document.querySelector('.spr-badge-caption')){
          let review = document.querySelector('.spr-badge-caption').innerHTML;
          if( review != "No reviews" ){
            review = review.replace('review','');
            document.querySelector('.spr-badge-caption').innerHTML = review;
          }
        }
        document.querySelector('.spr-badge-caption') ? clearInterval(reviewInterval) : '';
      }, 2000);
    }

}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();
